import React, {useState} from "react";
import {Typography} from "@mui/material";
import ETLJobExecutionTableApplet from "../eoec/applet/impl/ETLJob/ETLJobExecutionTableApplet";
import {makeEnterpriseComponent} from "../util/utility";


export default function Executions() {
    const [etlJobExecutionEnterpriseComponent] = useState(makeEnterpriseComponent("ETLJobExecution"));

    function renderExecutions() {

        return (
           <div style={{display: "flex", flexDirection: "column", margin: "20px 20px 20px 20px"}}>
               <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", margin: "30px 0 0 0"}}>
                    <ETLJobExecutionTableApplet enterpriseComponent={etlJobExecutionEnterpriseComponent}/>
                </div>
           </div>
        )
    }

    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: 52, backgroundColor: "#1498D8"}}>
                <div style={{paddingTop: "9px", paddingLeft: "20px"}}>
                    <Typography style={{fontSize: 24, fontWeight: 400, color: "#FFFFFF"}}>Executions</Typography>
                </div>
            </div>
            {renderExecutions()}
        </div>
    );
}